import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/style.css"; // Assuming styles cover all sections
import "../Styles/mobile-res.css";

// Importing image assets for banner fallback (optional)
import bannermobile from "../Asstes/Images/he-organisations.jpg";
import hrBannerDesktop from "../Asstes/Images/hroutsourcing-banner.jpg";
import listIcon from "../Asstes/Images/lists-icon.svg";

const HrOutsourcingPage = () => {
  const [bannerData, setBannerData] = useState(null);
  const [contents, setContents] = useState([]);

  useEffect(() => {
    // Fetch banner data
    axios
      .get("/prosapiens-cms/public/api/banners/hr-outsourcing")
      .then((res) => {
        if (res.data?.banners?.length > 0) {
          setBannerData(res.data.banners[0]);
        }
      })
      .catch((err) => console.error("Banner fetch error:", err));

    // Fetch content data
    axios
      .get("/prosapiens-cms/public/api/content/hr-outsourcing")
      .then((res) => {
        if (res.data?.content?.length > 0) {
          setContents(res.data.content);
        }
      })
      .catch((err) => console.error("Content fetch error:", err));
  }, []);

  // Helper: Extract image HTML and remaining text HTML separately
  const extractImageAndText = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const img = div.querySelector("img");
    const imgHTML = img ? img.outerHTML : "";
    if (img) img.remove();
    return { imgHTML, textHTML: div.innerHTML };
  };

  return (
    <>
      {/* Banner Section */}
      <section
        className="hroutsourcing-banner hroutsourcing-mobile"
        style={{
          backgroundImage: bannerData
            ? `url(/prosapiens-cms/public/${bannerData.banner_image})`
            : `url(${window.innerWidth < 768 ? bannermobile : hrBannerDesktop})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="overlay container" style={{color : "#fff"}}>
          {bannerData ? (
            <div
              className="hero-text" 
              dangerouslySetInnerHTML={{ __html: bannerData.content_text }}
            />
          ) : (
           null
          )}
        </div>
      </section>

      {/* Dynamic Content Sections */}
     {contents.map((item) => {
  // For content_order = 1: use the separate image field (content_image) for image side
  if (item.content_order === "1") {
    const imageUrl = `/prosapiens-cms/public/${item.content_image}`;

    return (
      <section className="what-we-do" key={item.id}>
        <div className="container">
          <div className="image-container">
            <div className="image-side" data-aos="fade-right">
              <img src={imageUrl} alt={item.content_title || "Content Image"} />
            </div>
            <div
              className="text-side"
              data-aos="fade-left"
              dangerouslySetInnerHTML={{ __html: item.content_text }}
            />
          </div>
        </div>
      </section>
    );
  }

  // For content_order = 2: full width HTML content
  if (item.content_order === "2") {
    return (
      <section className="hr-counter" key={item.id}>
        <div className="container" dangerouslySetInnerHTML={{ __html: item.content_text }} />
      </section>
    );
  }

  return null;
})}

    </>
  );
};

export default HrOutsourcingPage;
